import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Layout from 'components/Layout'
import Header from 'components/Cognito/Shared/Header'

import bgImg from 'images/login-desktop-bg.png'
import FormHeader from 'components/Cognito/Shared/FormHeader'
import SetupMFA from 'components/Cognito/MFA/Setup/SetupMFA'
import PostAuthenticatorSetup from 'components/Cognito/MFA/Setup/PostAuthenticatorSetup'
import authApi from 'api/auth'
import { useCognito, useCognitoDispatch } from 'components/Cognito/CognitoContextProvider'
import useIsFirstRender from 'hooks/useFirstRender'

export default function SetupMFAPage() {
  const { t } = useTranslation()
  const history = useHistory()
  const [fetchedMFASettings, setFetchedMFASettings] = useState(false)
  const { mfaSetup } = useCognito()
  const { promoteTemporarySession } = useCognitoDispatch()
  const user = useSelector((state) => state.user)
  const firstRender = useIsFirstRender()

  useEffect(() => {
    if (fetchedMFASettings || !mfaSetup?.accessToken) {
      return
    }

    authApi
      .getMFASettings(mfaSetup.accessToken)
      .then(({ data, status }) => {
        setFetchedMFASettings(true)
        if (status === 200 && data.required) {
          history.replace('/')
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }, [history, mfaSetup, fetchedMFASettings])

  useEffect(() => {
    if (!firstRender) return
    if (!mfaSetup?.accessToken) {
      history.replace('/')
    }
  }, [firstRender, mfaSetup, history])

  return (
    <Layout title={t('SetupMFA.PageTitle')}>
      <Helmet bodyAttributes={{ class: 'authentication-page setup-mfa-page' }} />
      <div>
        <Header showBack={false} />
        <main data-cy="setup-mfa-form-cy">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg">
                <div className="setup-mfa-container">
                  {!user.isLogged && (
                    <>
                      <FormHeader
                        title={t('SetupMFA.header')}
                        subtitle={t('SetupMFA.description')}
                      />
                      <SetupMFA onAuthenticatorSetupSuccess={promoteTemporarySession} />
                    </>
                  )}
                  {user.isLogged &&  <PostAuthenticatorSetup />}
                </div>
              </div>
              <div
                className="col-lg-auto d-none d-lg-block px-lg-0 image-col"
                style={{ backgroundImage: `url('${bgImg}')` }}
              ></div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}
